<section>
  <div>
    <h1 class="-blue">Adicionado com sucesso</h1>
    <h2>As exportações serão realizadas somente na conclusão</h2>
    <button (click)="close();">Ok</button>
  </div>
</section>
